module.exports = "pegasus_template/assets/social-2-basic.png";